import { NewsItemStatus } from './NewsUtils';

export enum NewsDisplayStatus {
    Draft = 'draft',
    Scheduled = 'scheduled',
    Live = 'live',
    Expired = 'expired',
    Archived = 'archived'
}

type NewsStatusInput = {
    status?: number;
    visible: boolean;
    startDate: string | null;
    endDate: string | null;
};

export function getNewsDisplayStatus(news: NewsStatusInput, today: string): NewsDisplayStatus {
    if (news.status === NewsItemStatus.Archived) {
        return NewsDisplayStatus.Archived;
    }
    if (!news.visible) {
        return NewsDisplayStatus.Draft;
    }
    if (news.startDate && news.startDate.substring(0, 10) > today) {
        return NewsDisplayStatus.Scheduled;
    }
    if (news.endDate && news.endDate.substring(0, 10) < today) {
        return NewsDisplayStatus.Expired;
    }
    return NewsDisplayStatus.Live;
}
